"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUploadStatus = void 0;
var FileUploadStatus;
(function (FileUploadStatus) {
    FileUploadStatus["Available"] = "AVAILABLE";
    FileUploadStatus["Pending"] = "PENDING";
    FileUploadStatus["Deleted"] = "DELETED";
})(FileUploadStatus = exports.FileUploadStatus || (exports.FileUploadStatus = {}));
